"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CCheckBox = _interopRequireDefault(require("01_core/components/materials/CCheckBox"));
var _HintMark = _interopRequireDefault(require("01_core/components/materials/HintMark"));
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _Consts = require("../../common/consts/Consts");
var _MedplanListTable = _interopRequireDefault(require("./MedplanListTable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PaddingLeft = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    paddingLeft: theme.spacing(1)
  };
});
const ColumnHintMark = (0, _styles.styled)(_HintMark.default)({
  color: 'white'
});
const BorderTopRow = (0, _styles.styled)(_material.TableRow)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    borderTop: 'solid 1px',
    borderTopColor: theme.palette.border.white
  };
});
const CenterTypography = (0, _styles.styled)(_material.Typography)({
  textAlign: 'center'
});
const TgtRiskCell = (0, _styles.styled)(_material.TableCell)({
  width: '15%'
});
const TgtRiskOtherCell = (0, _styles.styled)(_material.TableCell)({
  width: '35%'
});
const KunrenPeriodCell = (0, _styles.styled)(_material.TableCell)({
  width: '25%'
});

/**
 * 中期計画情報（表示用）
 */
class MedplanFieldDisp extends _react.default.Component {
  render() {
    const {
      intl,
      entries
    } = this.props;
    // カラム
    const columns = [{
      dataKey: 'kunrenNendo',
      label: /*#__PURE__*/_react.default.createElement(PaddingLeft, null, intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN_KUNREN_NENDO
      })),
      width: 150
    }, {
      dataKey: 'targetRisk',
      label: /*#__PURE__*/_react.default.createElement(_material.Table, null, /*#__PURE__*/_react.default.createElement(_material.TableHead, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, null, /*#__PURE__*/_react.default.createElement(_material.TableCell, {
        colSpan: 4
      }, /*#__PURE__*/_react.default.createElement(PaddingLeft, null, intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TGT_RISK
      }), /*#__PURE__*/_react.default.createElement(ColumnHintMark, {
        hint: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN_TARGETRISK_HINT
      })))), /*#__PURE__*/_react.default.createElement(BorderTopRow, null, entries.th1Items.map((item, index) => {
        if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
          return /*#__PURE__*/_react.default.createElement(TgtRiskOtherCell, {
            rowSpan: 2,
            key: index
          }, /*#__PURE__*/_react.default.createElement(PaddingLeft, null, item.contents));
        } else {
          return /*#__PURE__*/_react.default.createElement(TgtRiskCell, {
            rowSpan: 2,
            key: index
          }, /*#__PURE__*/_react.default.createElement(PaddingLeft, null, item.contents));
        }
      })), /*#__PURE__*/_react.default.createElement(_material.TableRow, null))),
      width: 500
    }, {
      dataKey: 'kunrenPeriod',
      label: /*#__PURE__*/_react.default.createElement(_material.Table, null, /*#__PURE__*/_react.default.createElement(_material.TableHead, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, null, /*#__PURE__*/_react.default.createElement(_material.TableCell, {
        colSpan: 4
      }, /*#__PURE__*/_react.default.createElement(PaddingLeft, null, intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PERIOD
      }), /*#__PURE__*/_react.default.createElement(ColumnHintMark, {
        hint: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN_KUNRENSEASON_HINT
      })))), /*#__PURE__*/_react.default.createElement(BorderTopRow, null, entries.th2Items.map((item, index) => {
        return /*#__PURE__*/_react.default.createElement(KunrenPeriodCell, {
          rowSpan: 2,
          key: index
        }, /*#__PURE__*/_react.default.createElement(PaddingLeft, null, item.contents));
      })), /*#__PURE__*/_react.default.createElement(_material.TableRow, null))),
      width: 500
    }, {
      dataKey: 'kunrenPurpose',
      label: /*#__PURE__*/_react.default.createElement(PaddingLeft, null, intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PURPOSE
      })),
      width: 230
    }, {
      dataKey: 'notes',
      label: /*#__PURE__*/_react.default.createElement(PaddingLeft, null, intl.formatMessage({
        id: _labelConsts.LABEL.CORE_NOTE
      })),
      width: 230
    }];

    // 中期計画表データ
    const createRow = n => {
      //過去年度で未登録の場合
      if (n.dataRegistered === false && n.pastYearFlg === true) {
        const kunrenNendo = /*#__PURE__*/_react.default.createElement(_material.Typography, null, n.kunrenNendo, intl.formatMessage({
          id: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN_KUNREN_NENDO
        }));
        const targetRisk = /*#__PURE__*/_react.default.createElement(CenterTypography, null, n.kunrenNendo, intl.formatMessage({
          id: _labelConsts.LABEL.BCM_KUNREN_NO_REGISTERED
        }));
        const kunrenPeriod = _stringConsts.STRING_CONSTS.EMPTY;
        const kunrenPurpose = _stringConsts.STRING_CONSTS.EMPTY;
        const notes = _stringConsts.STRING_CONSTS.EMPTY;
        const pastYearFlg = n.pastYearFlg;
        const nowYearFlg = n.nowYearFlg;
        const pastRegisterdFlg = false;
        return {
          kunrenNendo,
          targetRisk,
          kunrenPeriod,
          kunrenPurpose,
          notes,
          pastYearFlg,
          nowYearFlg,
          pastRegisterdFlg
        };
      } else {
        const targetRiskList = entries.checkStatusList.filter(item => {
          return item.kunrenNendo === n.kunrenNendo && item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01;
        });
        const kunrenPeriodList = entries.checkStatusList.filter(item => {
          return item.kunrenNendo === n.kunrenNendo && item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_02;
        });
        const kunrenNendo = /*#__PURE__*/_react.default.createElement(_material.Typography, null, n.kunrenNendo, intl.formatMessage({
          id: _labelConsts.LABEL.BCM_KUNREN_MEDPLAN_KUNREN_NENDO
        }));
        const targetRisk = /*#__PURE__*/_react.default.createElement(_material.Table, null, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, null, /* 対象リスク */
        targetRiskList.map((item, index) => {
          if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
            return /*#__PURE__*/_react.default.createElement(TgtRiskOtherCell, {
              key: index
            }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, _stringUtil.default.emptyToHyphen(item.notes)));
          } else {
            return /*#__PURE__*/_react.default.createElement(TgtRiskCell, {
              key: index
            }, /*#__PURE__*/_react.default.createElement(_CCheckBox.default, {
              checked: Number(item.activityFlg),
              onChange: () => {},
              style: {
                cursor: 'default'
              },
              color: "secondary",
              labelVariant: "body2"
            }));
          }
        }))));
        const kunrenPeriod = /*#__PURE__*/_react.default.createElement(_material.Table, null, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, null, /* 訓練時期 */
        kunrenPeriodList.map((item, index) => {
          if (item.displayFlg) {
            return /*#__PURE__*/_react.default.createElement(KunrenPeriodCell, {
              key: index
            }, /*#__PURE__*/_react.default.createElement(_CCheckBox.default, {
              checked: Number(item.activityFlg),
              onChange: () => {},
              style: {
                cursor: 'default'
              },
              color: "secondary",
              labelVariant: "body2"
            }));
          } else {
            return /*#__PURE__*/_react.default.createElement(KunrenPeriodCell, {
              key: index
            });
          }
        }))));
        const kunrenPurpose = /*#__PURE__*/_react.default.createElement(_material.Typography, null, _stringUtil.default.emptyToHyphen(n.kunrenPurpose));
        const notes = /*#__PURE__*/_react.default.createElement(_material.Typography, null, _stringUtil.default.emptyToHyphen(n.notes));
        const pastYearFlg = n.pastYearFlg;
        const nowYearFlg = n.nowYearFlg;
        const pastRegisterdFlg = true;
        return {
          kunrenNendo,
          targetRisk,
          kunrenPeriod,
          kunrenPurpose,
          notes,
          pastYearFlg,
          nowYearFlg,
          pastRegisterdFlg
        };
      }
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MedplanListTable.default, {
      rowData: entries.medPlanList,
      columns,
      createRow
    }));
  }
}
var _default = exports.default = (0, _reactIntl.injectIntl)(MedplanFieldDisp);